module.exports = __webpack_public_path__ + "img/users.be98b4ba.svg";